import { LogoMark } from "./Logo";
import { NAV, PHONE, TEL, scrollToId } from "./data";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-[var(--line)]">
    <div className="mx-auto max-w-[1400px] px-5 pt-16 sm:px-8">
      <div className="grid gap-10 md:grid-cols-3">
        <div className="flex items-start gap-4">
          <LogoMark className="h-28 w-auto" />
          <p className="text-sm leading-relaxed text-zinc-400">Warrior Towing &amp; Recovery LLC<br />Charlotte, North Carolina</p>
        </div>
        <ul className="flex flex-col gap-3">
          {NAV.map((n) => (
            <li key={n.id}>
              <button data-testid={`footer-link-${n.id}`} onClick={() => scrollToId(n.id)} className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-300 transition-colors hover:text-[var(--signal)]">{n.label}</button>
            </li>
          ))}
        </ul>
        <a href={TEL} data-testid="footer-phone" className="font-display text-4xl font-black transition-colors hover:text-[var(--signal)] md:text-right">{PHONE}</a>
      </div>
      <p aria-hidden="true" className="mt-16 select-none font-display text-[24vw] font-black uppercase leading-[0.75] tracking-tighter text-[var(--ink-2)] [-webkit-text-stroke:1px_rgba(244,241,234,0.08)]">Warrior</p>
      <div className="flex flex-col gap-2 border-t border-[var(--line)] py-6 font-mono text-xs text-zinc-400 sm:flex-row sm:justify-between">
        <span>© {new Date().getFullYear()} Warrior Towing &amp; Recovery LLC</span>
        <span>Private property impound · Charlotte, NC</span>
      </div>
    </div>
  </footer>
);
